import { useToast } from '@chakra-ui/react'
import useConfigList from '../../../../hooks/useConfigList'
import useNavigateNext from '../../../../hooks/useNavigateNext'
import useUpdateReportDoc from '../../../../hooks/useUpdateReportDoc'
import useCurrentReport from '../../../../hooks/useCurrentReport'
import { PhysicalStrategiesFormState } from '../utils/types'

export const usePhysicalStrategiesFormState =
  (): PhysicalStrategiesFormState => {
    const toast = useToast()
    const items = useConfigList('physicalStrategies')
    const dentalItems = useConfigList('dentalProcedures')
    const navNext = useNavigateNext()
    const updateReport = useUpdateReportDoc()
    const currentReport = useCurrentReport()

    const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault()
      
      // Validate physical strategy checkbox
      if (!currentReport?.physicalStrategyListIsAccurate) {
        toast({
          status: 'warning',
          title: 'Physical Strategy List Accurate?',
          description: `Please check the box confirming your physical strategy list is currently accurate.`,
        })
        return false
      }
      
      // Validate dental checkbox
      if (!currentReport?.dentalListIsAccurate) {
        toast({
          status: 'warning',
          title: 'Dental List Accurate?',
          description: `Please check the box confirming your dental list is currently accurate.`,
        })
        return false
      }
      
      updateReport({ physicalStrategies: true })
      navNext()
    }

    const physicalLists = [
      {
        fieldId: 'physicalStrategyId',
        label: 'Strategy',
        items,
        id: 'physicalStrategies',
      },
    ]

    const dentalLists = [
      {
        fieldId: 'dentalProcedureId',
        label: 'Dental Procedure',
        items: dentalItems,
        id: 'dentalProcedures',
      },
    ]

    return {
      handleSubmit,
      physicalLists,
      dentalLists,
    }
  }
